const setResumeProjects = (projects) => ({
    type: 'SET_RESUME_PROJECTS',
    projects,
});

export default setResumeProjects;
